export default function Marquee({ items, className = "" }) {
  const Row = ({ hidden }) => (
    <div className="flex shrink-0 items-center" aria-hidden={hidden || undefined}>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="whitespace-nowrap px-6 font-mono text-xs uppercase tracking-[0.25em] text-white/70 md:px-10 md:text-sm">
            {item}
          </span>
          <span className="h-1.5 w-1.5 shrink-0 rotate-45 bg-brand-cyan/80" aria-hidden="true" />
        </span>
      ))}
    </div>
  );
  return (
    <div
      className={`overflow-hidden border-y border-white/10 bg-brand-teal/40 py-5 ${className}`}
      data-testid="services-marquee"
    >
      <div className="marquee flex w-max">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
